import React, { useState, useEffect } from 'react';
import { ref, get, push, set, update, remove } from 'firebase/database';
import { database } from '../firebase/config';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import PulsantiCondivisionePDF from './PulsantiCondivisionePDF';
import '../styles/Liste.css';
import { formattaData } from '../utils/dateUtils'; 
import { useFirebaseData } from '../hooks/useFirebaseData'; 

// Stili per il PDF del report cliente
const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica'
  },
  header: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
    color: '#2c3e50',
    fontWeight: 'bold'
  },
  subheader: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: '#7f8c8d'
  },
  infoBox: {
    backgroundColor: '#e3f2fd',
    padding: 10,
    marginBottom: 15,
    borderRadius: 5
  },
  infoText: {
    fontSize: 11,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dee2e6',
    minHeight: 25,
    alignItems: 'center'
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: 9
  },
  tableCol: {
    padding: 5,
    fontSize: 8
  },
  col1: { width: '10%' },
  col2: { width: '12%' },
  col3: { width: '12%' },
  col4: { width: '8%' },
  col5: { width: '8%' },
  col6: { width: '8%' },
  col7: { width: '14%' },
  col8: { width: '28%' },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 8,
    color: '#95a5a6'
  }
});


function ListaClienti() {
  const { dipendenti, veicoli, cantieri,
    caricaDipendenti, caricaVeicoli, caricaCantieri
  } = useFirebaseData();
  const [clienti, setClienti] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    ragioneSociale: '',
    email: '',
    telefono: '',
    indirizzo: '',
    cap: '',
    citta: ''
  });

  const [showReportModal, setShowReportModal] = useState(false);
  const [clienteSelezionato, setClienteSelezionato] = useState(null);
  const [programmiCliente, setProgrammiCliente] = useState([]);
  const [ordinamentoReport, setOrdinamentoReport] = useState({
    campo: 'data',
    direzione: 'desc'
  });


  useEffect(() => {
    caricaClienti();
  }, []);

  async function caricaClienti() {
    const clientiRef = ref(database, 'clienti');
    const snapshot = await get(clientiRef);
    
    if (snapshot.exists()) {
      const data = snapshot.val();
      const clientiArray = Object.keys(data).map(key => ({
        id: key,
        ...data[key]
      }));
      setClienti(clientiArray);
    } else {
      setClienti([]);
    }
  }

  function apriModal(cliente = null) {
    if (cliente) {
      setEditingId(cliente.id);
      setFormData({
        ragioneSociale: cliente.ragioneSociale || '',
        email: cliente.email || '',
        telefono: cliente.telefono || '',
        indirizzo: cliente.indirizzo || '',
        cap: cliente.cap || '',
        citta: cliente.citta || ''
      });
    } else {
      setEditingId(null);
      setFormData({
        ragioneSociale: '',
        email: '',
        telefono: '',
        indirizzo: '',
        cap: '',
        citta: ''
      });
    }
    setShowModal(true);
  }

  function chiudiModal() {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      ragioneSociale: '',
      email: '',
      telefono: '',
      indirizzo: '',
      cap: '',
      citta: ''
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!formData.ragioneSociale || !formData.email) {
      alert('Compila tutti i campi');
      return;
    }

    // Validazione email semplice
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Inserisci un\'email valida');
      return;
    }

    try {
      if (editingId) {
        const clienteRef = ref(database, `clienti/${editingId}`);
        await update(clienteRef, {
          ragioneSociale: formData.ragioneSociale,
          email: formData.email,
          telefono: formData.telefono,
          indirizzo: formData.indirizzo,
          cap: formData.cap,
          citta: formData.citta
        });
        alert('Cliente modificato con successo!');
      } else {
        const clientiRef = ref(database, 'clienti');
        const newClienteRef = push(clientiRef);
        await set(newClienteRef, {
          ragioneSociale: formData.ragioneSociale,
          email: formData.email,
          telefono: formData.telefono,
          indirizzo: formData.indirizzo,
          cap: formData.cap,
          citta: formData.citta,
          createdAt: Date.now()
        });
        alert('Cliente creato con successo!');
      }
      
      chiudiModal();
      caricaClienti();
    } catch (error) {
      alert('Errore: ' + error.message);
    }
  }

  async function eliminaCliente(id, ragioneSociale) {
    if (window.confirm(`Sei sicuro di voler eliminare ${ragioneSociale}?`)) {
      try {
        const clienteRef = ref(database, `clienti/${id}`);
        await remove(clienteRef);
        alert('Cliente eliminato!');
        caricaClienti();
      } catch (error) {
        alert('Errore: ' + error.message);
      }
    }
  }


  async function apriReportCliente(cliente) {
    setClienteSelezionato(cliente);
    setShowReportModal(true);
    
    await Promise.all([
      caricaCantieri(),
      caricaProgrammiCliente(cliente.id),
      caricaDipendenti(),
      caricaVeicoli()
    ]);
  }

  async function caricaProgrammiCliente(clienteId) {
    try {
      // Prima carica i cantieri del cliente
      const cantieriRef = ref(database, 'cantieri');
      const cantieriSnapshot = await get(cantieriRef);
      
      let cantieriDelCliente = [];
      if (cantieriSnapshot.exists()) {
        const cantieriData = cantieriSnapshot.val();
        cantieriDelCliente = Object.keys(cantieriData)
          .filter(key => cantieriData[key].clienteId === clienteId)
          .map(key => key);
      }

      // Poi carica i programmi di quei cantieri
      const programmiRef = ref(database, 'programmi-lavorativi');
      const snapshot = await get(programmiRef);
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        const programmiArray = Object.keys(data)
          .map(key => ({ id: key, ...data[key] }))
          .filter(prog => cantieriDelCliente.includes(prog.cantiereId))
          .sort((a, b) => new Date(b.data) - new Date(a.data));
        
        setProgrammiCliente(programmiArray);
      } else {
        setProgrammiCliente([]);
      }
    } catch (error) {
      console.error('Errore caricamento programmi:', error);
      setProgrammiCliente([]);
    }
  }


  function chiudiReportModal() {
    setShowReportModal(false);
    setClienteSelezionato(null);
    setProgrammiCliente([]);
  }

  function getDipendente(id) {
    return dipendenti.find(d => d.id === id);
  }

  function getVeicolo(id) {
    return veicoli.find(v => v.id === id);
  }

  function getCantiere(id) {
    return cantieri.find(c => c.id === id);
  }

  function handleOrdinamentoReport(campo) {
    let direzione = 'asc';
    
    if (ordinamentoReport.campo === campo && ordinamentoReport.direzione === 'asc') {
      direzione = 'desc';
    }
    
    setOrdinamentoReport({ campo, direzione });
  }

  function getProgrammiOrdinati() {
    const programmiCopia = [...programmiCliente];
    
    programmiCopia.sort((a, b) => {
      let valoreA, valoreB;
      
      if (ordinamentoReport.campo === 'data') {
        valoreA = new Date(a.data);
        valoreB = new Date(b.data);
      } else if (ordinamentoReport.campo === 'dipendente') {
        const dipA = getDipendente(a.dipendenteId);
        const dipB = getDipendente(b.dipendenteId);
        valoreA = dipA ? dipA.cognome.toLowerCase() : '';
        valoreB = dipB ? dipB.cognome.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'veicolo') {
        const veicA = getVeicolo(a.veicoloId);
        const veicB = getVeicolo(b.veicoloId);
        valoreA = veicA ? `${veicA.marca} ${veicA.modello}`.toLowerCase() : '';
        valoreB = veicB ? `${veicB.marca} ${veicB.modello}`.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'cantiere') {
        const cantA = getCantiere(a.cantiereId);
        const cantB = getCantiere(b.cantiereId);
        valoreA = cantA ? cantA.luogo.toLowerCase() : '';
        valoreB = cantB ? cantB.luogo.toLowerCase() : '';
      }
      
      if (valoreA < valoreB) {
        return ordinamentoReport.direzione === 'asc' ? -1 : 1;
      }
      if (valoreA > valoreB) {
        return ordinamentoReport.direzione === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    return programmiCopia;
  }

  function getFrecciaReport(campo) {
    if (ordinamentoReport.campo !== campo) {
      return '↕️';
    }
    return ordinamentoReport.direzione === 'asc' ? '🔼' : '🔽';
  }

  const ReportClientePDF = ({ cliente, programmi }) => (
    <Document>
      <Page size="A4" orientation="landscape" style={pdfStyles.page}>
        <Text style={pdfStyles.header}>Cliente</Text>
        <Text style={pdfStyles.subheader}>
          {cliente.ragioneSociale}
        </Text>
        
        <View style={pdfStyles.infoBox}>
          <Text style={pdfStyles.infoText}>
            Totale Programmi: {programmi.length}
          </Text>
        </View>

        <View style={pdfStyles.table}>
          <View style={[pdfStyles.tableRow, pdfStyles.tableHeader]}>
            <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>Data</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>Dipendente</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>Veicolo</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>Inizio</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>Fine</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>Durata</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>Cantiere</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>Note</Text>
          </View>

          {programmi.map((prog, index) => {
            const dipendente = getDipendente(prog.dipendenteId);
            const veicolo = getVeicolo(prog.veicoloId);
            const cantiere = getCantiere(prog.cantiereId);

            return (
              <View key={index} style={pdfStyles.tableRow}>
                <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>{formattaData(prog.data)}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>
                  {dipendente ? `${dipendente.nome} ${dipendente.cognome}` : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>
                  {veicolo ? `${veicolo.marca} ${veicolo.modello}` : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>{prog.orarioInizio}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>{prog.orarioFine}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>{prog.durataLavoro}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>
                  {cantiere ? cantiere.luogo : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>
                  {prog.note || '-'}
                </Text>
              </View>
            );
          })}
        </View>

        <Text style={pdfStyles.footer}>
          Report generato il {new Date().toLocaleDateString('it-IT')} alle {new Date().toLocaleTimeString('it-IT')}
        </Text>
      </Page>
    </Document>
  );


  return (
    <div className="lista-container">
      <div className="lista-header">
        <h2>🏢 Gestione Clienti</h2>
        <button className="btn-add" onClick={() => apriModal()}>
          + Aggiungi Cliente
        </button>
      </div>

      {clienti.length === 0 ? (
        <div className="empty-state">
          <p>Nessun cliente presente.</p>
          <p>Clicca su "Aggiungi Cliente" per iniziare.</p>
        </div>
      ) : (
        <>
          {/* Tabella Desktop */}
          <table className="data-table">
            <thead>
              <tr>
                <th>Ragione Sociale</th>
                <th>Email</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {clienti.map(cliente => (
                <tr key={cliente.id}>
                  <td>{cliente.ragioneSociale}</td>
                  <td>{cliente.email}</td>
                  <td className="actions">
                    <button 
                      className="btn-edit"
                      onClick={() => apriReportCliente(cliente)}
                      style={{background: '#9b59b6'}}
                    >
                      <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-edit"
                      onClick={() => apriModal(cliente)}
                    >
                      <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => eliminaCliente(cliente.id, cliente.ragioneSociale)}
                    >
                      <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Layout Card Mobile */}
          <div className="mobile-cards">
            {clienti.map(cliente => (
              <div key={cliente.id} className="mobile-card">
                <div className="mobile-card-header">
                  🏢 {cliente.ragioneSociale}
                </div>
                
                <div className="mobile-card-row">
                  <span className="mobile-card-label">Email:</span>
                  <span className="mobile-card-value">{cliente.email}</span>
                </div>
                
                <div className="mobile-card-actions">
                  <button 
                    className="btn-edit"
                    onClick={() => apriReportCliente(cliente)}
                    style={{background: '#9b59b6'}}
                  >
                    <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-edit"
                    onClick={() => apriModal(cliente)}
                  >
                    <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-delete"
                    onClick={() => eliminaCliente(cliente.id, cliente.ragioneSociale)}
                  >
                    <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={chiudiModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{editingId ? 'Modifica Cliente' : 'Nuovo Cliente'}</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Ragione Sociale *</label>
                <input
                  type="text"
                  value={formData.ragioneSociale}
                  onChange={(e) => setFormData({...formData, ragioneSociale: e.target.value})}
                  placeholder="es. Azienda Edile Rossi S.r.l."
                  required
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="es. info@azienda.com"
                  required
                />
              </div>

              <div className="form-group">
                <label>Telefono</label>
                <input
                  type="tel"
                  value={formData.telefono}
                  onChange={(e) => setFormData({...formData, telefono: e.target.value.replace(/\D/g, '')})}
                  placeholder="es. 781234567"
                />
              </div>

              <div className="form-group">
                <label>Indirizzo</label>
                <input
                  type="text"
                  value={formData.indirizzo}
                  onChange={(e) => setFormData({...formData, indirizzo: e.target.value})}
                  placeholder="es. Via Roma 1"
                />
              </div>

              <div className="form-group">
                <label>CAP</label>
                <input
                  type="tel"
                  value={formData.cap}
                  onChange={(e) => setFormData({...formData, cap: e.target.value.replace(/\D/g, '').slice(0, 5)})}
                  placeholder="es. 6830"
                />
              </div>

              <div className="form-group">
                <label>Città</label>
                <input
                  type="text"
                  value={formData.citta}
                  onChange={(e) => setFormData({...formData, citta: e.target.value})}
                  placeholder="es. Chiasso"
                />
              </div>

              <div className="modal-buttons">
                <button type="button" className="btn-cancel" onClick={chiudiModal}>
                  Annulla
                </button>
                <button type="submit" className="btn-save">
                  {editingId ? 'Salva Modifiche' : 'Crea Cliente'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Report Cliente */}
      {showReportModal && clienteSelezionato && (
        <div className="modal-overlay" onClick={chiudiReportModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{maxWidth: '90%', maxHeight: '90vh', overflow: 'auto'}}
          >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px'}}>
              <h3 style={{margin: 0}}>📊 Report cliente: {clienteSelezionato.ragioneSociale}</h3>
              <button 
                onClick={chiudiReportModal}
                style={{
                  background: '#95a5a6',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                ✕
              </button>
            </div>

            {programmiCliente.length === 0 ? (
              <div style={{textAlign: 'center', padding: '40px', color: '#7f8c8d'}}>
                <p>Nessun programma lavorativo trovato per questo cliente.</p>
              </div>
            ) : (
              <>
                {/* 👇 Riga gialla con bottone PDF */}
                <div style={{
                  background: '#efd400',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  <strong>Totale programmi: {programmiCliente.length}</strong>
                  
                  <PulsantiCondivisionePDF
                    documentoPDF={<ReportClientePDF cliente={clienteSelezionato} programmi={getProgrammiOrdinati()} />}
                    nomeFile={`Report_Cliente_${clienteSelezionato.ragioneSociale.replace(/ /g, '_')}.pdf`}
                    testoCondivisione={`📊 Report Cliente\n\n🏢 ${clienteSelezionato.ragioneSociale}\n📧 ${clienteSelezionato.email}\n📋 ${programmiCliente.length} programmi totali`}
                    emailDestinatario={clienteSelezionato.email}
                    oggettoEmail={`Report Programmi - ${clienteSelezionato.ragioneSociale}`}
                    corpoEmail={`Gentile Cliente,\n\nallego il report completo dei lavori svolti per:\n\nCLIENTE: ${clienteSelezionato.ragioneSociale}\nTOTALE PROGRAMMI: ${programmiCliente.length}\n\nCordiali saluti`}
                  />
                </div>

                {/* 👇 TABELLA DESKTOP (nascosta su mobile) */}
                <div style={{overflowX: 'auto'}} className="desktop-only">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th 
                          onClick={() => handleOrdinamentoReport('data')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Data {getFrecciaReport('data')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('dipendente')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Dipendente {getFrecciaReport('dipendente')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('veicolo')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Veicolo {getFrecciaReport('veicolo')}
                        </th>
                        <th>Orario Inizio</th>
                        <th>Orario Fine</th>
                        <th>Durata</th>
                        <th 
                          onClick={() => handleOrdinamentoReport('cantiere')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Cantiere {getFrecciaReport('cantiere')}
                        </th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getProgrammiOrdinati().map(prog => {
                        const dipendente = getDipendente(prog.dipendenteId);
                        const veicolo = getVeicolo(prog.veicoloId);
                        const cantiere = getCantiere(prog.cantiereId);

                        return (
                          <tr key={prog.id}>
                            <td><strong>{formattaData(prog.data)}</strong></td>
                            <td>
                              {dipendente ? (
                                <>
                                  {dipendente.nome} {dipendente.cognome}
                                </>
                              ) : 'N/D'}
                            </td>
                            <td>
                              {veicolo ? (
                                <>
                                  {veicolo.marca} {veicolo.modello}
                                  <br/>
                                  <small style={{color: '#666'}}>({veicolo.targa})</small>
                                </>
                              ) : 'N/D'}
                            </td>
                            <td>{prog.orarioInizio}</td>
                            <td>{prog.orarioFine}</td>
                            <td><strong>{prog.durataLavoro}</strong></td>
                            <td>{cantiere ? cantiere.luogo : 'N/D'}</td>
                            <td style={{maxWidth: '200px', fontSize: '12px'}}>
                              {prog.note || '-'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* 👇 LAYOUT CARD MOBILE (nascosto su desktop) */}
                <div className="mobile-cards">
                  {getProgrammiOrdinati().map(prog => {
                    const dipendente = getDipendente(prog.dipendenteId);
                    const veicolo = getVeicolo(prog.veicoloId);
                    const cantiere = getCantiere(prog.cantiereId);

                    return (
                      <div key={prog.id} className="mobile-card">
                        <div className="mobile-card-header">
                          📅 {formattaData(prog.data)}
                        </div>
                        
                        <div className="mobile-card-row">
                          <span className="mobile-card-label">👤 Dipendente:</span>
                          <span className="mobile-card-value">
                            {dipendente ? `${dipendente.nome} ${dipendente.cognome}` : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🚗 Veicolo:</span>
                          <span className="mobile-card-value">
                            {veicolo ? `${veicolo.marca} ${veicolo.modello} (${veicolo.targa})` : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🕐 Orario:</span>
                          <span className="mobile-card-value">
                            {prog.orarioInizio} - {prog.orarioFine}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">⏱️ Durata:</span>
                          <span className="mobile-card-value">
                            <strong>{prog.durataLavoro}</strong>
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🏗️ Cantiere:</span>
                          <span className="mobile-card-value">
                            {cantiere ? cantiere.luogo : 'N/D'}
                          </span>
                        </div>

                        {prog.note && (
                          <div className="mobile-card-row">
                            <span className="mobile-card-label">📝 Note:</span>
                            <span className="mobile-card-value" style={{fontSize: '12px'}}>
                              {prog.note}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ListaClienti;
